var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BackendHttpService } from '../../core/backend-http.service';
import { apiEndpoints, CommonConstant } from '../../app.constants';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../user.service';
import { ObjectUtils } from '../../utils/object.utils';
var CommunicationService = /** @class */ (function (_super) {
    __extends(CommunicationService, _super);
    function CommunicationService(router, translate, userService) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.userService = userService;
        return _this;
    }
    /**
     * retrieve list of communication based on company id
     * @param {number} companyId, {number} offset, {Date} timeStamp
     * @returns {Observable<[{id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string} , {id: number; status: number; sender: string; message: string}]>}
     */
    CommunicationService.prototype.fetchConservationList = function (companyId, offset, timeStamp) {
        var _this = this;
        return this.get(apiEndpoints.loadConservations.replace(':companyId', companyId.toString()), {
            limit: CommonConstant.DEFAULT_CHAT_MESSAGES_SIZE,
            offset: offset,
            timestamp: timeStamp.getTime()
        }).map(function (res) { return res && res.data ? {
            offset: offset + res.data.conversations.length,
            conversations: _this.normalizeConversationList(res.data.conversations, companyId)
        } : {
            offset: offset,
            conversations: []
        }; });
    };
    /**
     * get contact permission data based on token
     * @param permissionToken
     * @returns {Observable<ContactPermission>}
     */
    CommunicationService.prototype.getPermissionByToken = function (permissionToken) {
        return this.get(apiEndpoints.loadContactPermission + "?permissionToken=" + permissionToken).map(function (res) { return res && res.data ? ({
            id: res.data.permission_id,
            status: res.data.permission_status,
            influencerId: res.data.influencer_id,
            influencerName: res.data.influencer_name,
            advertiserName: res.data.advertiser_name,
            advertiserId: res.data.advertiser_id,
            agencyName: res.data.agency_name,
            expiresAt: res.data.expires_at
        }) : null; });
    };
    CommunicationService.prototype.normalizeConversationList = function (conversationList, companyId) {
        var _this = this;
        if (this.userService.isAdmin) {
            return conversationList.map(function (con) { return _this.normalizeConversationData(con, companyId); });
        }
        var newConversationList = conversationList.map(function (con) { return _this.normalizeConversationData(con, companyId); }).filter(function (c) { return !c.isHidden; });
        return newConversationList;
    };
    CommunicationService.prototype.normalizeConversationData = function (conversation, companyId) {
        var currentParticipant;
        var currentUser = ObjectUtils.parseJSON(localStorage.getItem('user'));
        currentParticipant = conversation.participants.find(function (p) { return p.user && currentUser && p.user.id === currentUser.data.id; });
        var numOfUnseenMessage = 0;
        if (currentParticipant && currentParticipant.lastSeenMessage) {
            var lastSeenTime_1 = currentParticipant.lastSeenMessage.date;
            numOfUnseenMessage = conversation.messages.filter(function (m) { return m.date > lastSeenTime_1 && m.participant && m.participant.id !== currentParticipant.id; }).length;
        }
        return Object.assign({}, conversation, {
            status: numOfUnseenMessage > 0 ? 1 /* Warning */ : 0 /* Normal */,
            isHidden: currentParticipant && currentParticipant.hidden,
            isJoined: typeof currentParticipant !== 'undefined',
            messages: this.normalizeConversationMessage(conversation, companyId)
        });
    };
    CommunicationService.prototype.fetchConversationDetails = function (companyId, conversationId, pageNo) {
        var _this = this;
        if (pageNo === void 0) { pageNo = 0; }
        return this.get(apiEndpoints.getConversationDetails.replace(':companyId', companyId.toString()).replace(':conversationId', conversationId.toString()), {
            limit: CommonConstant.DEFAULT_CHAT_MESSAGES_SIZE,
            offset: pageNo * CommonConstant.DEFAULT_CHAT_MESSAGES_SIZE
        }).map(function (res) { return res && res.data ? _this.normalizeConversationData(res.data, companyId) : null; });
    };
    CommunicationService.prototype.sendMessage = function (companyId, conversationId, content) {
        return this.post(apiEndpoints.getConversationDetails.replace(':companyId', companyId.toString()).replace(':conversationId', conversationId.toString()), {
            content: content,
            version: 1
        }).map(function (res) { return res.data; });
    };
    CommunicationService.prototype.fetchNewMessages = function (companyId, conversationId, lastActivity) {
        var _this = this;
        var endPoint = apiEndpoints.fetchNewMessages.replace(':companyId', companyId.toString()).replace(':conversationId', conversationId.toString());
        if (!lastActivity) {
            return this.get(endPoint).map(function (res) { return res && res.data ? _this.normalizeConversationMessage(res.data, companyId) : null; });
        }
        else {
            return this.get(endPoint, {
                lastActivity: lastActivity
            }).map(function (res) { return res && res.data ? _this.normalizeConversationMessage(res.data, companyId) : null; });
        }
    };
    CommunicationService.prototype.fetchInfluencerConversation = function (companyId, influencerId) {
        var _this = this;
        return this.get(apiEndpoints.fetchInfluencerConversation.replace(':companyId', companyId.toString()).replace(':influencerId', influencerId.toString()))
            .map(function (res) { return res && res.data ? _this.normalizeConversationData(res.data.conversation, companyId) : null; });
    };
    CommunicationService.prototype.markMessageAsSeen = function (companyId, conversationId, messageId) {
        return this.post(apiEndpoints.markMessageAsSeen.replace(':companyId', companyId.toString())
            .replace(':conversationId', conversationId.toString()).replace(':messageId', messageId), { message_id: messageId }).map(function (res) { return res ? res.data : null; });
    };
    CommunicationService.prototype.deleteConversation = function (companyId, conversationId) {
        return this.delete(apiEndpoints.getConversationDetails.replace(':companyId', companyId.toString())
            .replace(':conversationId', conversationId.toString())).map(function (res) { return res ? res.data : null; });
    };
    CommunicationService.prototype.normalizeConversationName = function (conversation) {
        var splitConversationName = conversation.name.split(', ');
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (currentInfluencer) {
            return splitConversationName.find(function (name) { return name !== currentInfluencer.name; });
        }
        else {
            var currentAdvertiser_1 = this.userService.getCurrentAdvertiser();
            if (currentAdvertiser_1) {
                return splitConversationName.find(function (name) { return name !== currentAdvertiser_1.name; });
            }
            return '';
        }
    };
    CommunicationService.prototype.normalizeConversationMessage = function (conversation, companyId) {
        var _this = this;
        var orderedMessages = conversation.messages.sort(function (a, b) { return a.date - b.date; });
        return orderedMessages.map(function (msg) { return ({
            id: msg.id,
            conservationId: conversation.id,
            sender: msg.participant ? msg.participant : null,
            content: msg.content,
            messageType: msg.messageType,
            type: _this.getMessageType(msg, companyId),
            recipientName: msg.participant && msg.participant.user ? msg.participant.user.fullName : null,
            sentTime: msg.date,
            campaignId: msg.campaignId,
            campaignInfluencerId: msg.campaignInfluencerId,
            status: msg.campaignStatus ? msg.campaignStatus.toLowerCase() : null,
            activityAuthor: msg.activityAuthor
        }); });
    };
    CommunicationService.prototype.getMessageType = function (message, companyId) {
        if (!message.participant ||
            message.messageType === "ACCEPTED_PERMISSION" /* accepted */ ||
            message.messageType === "REQUESTED_PERMISSION" /* requested */ ||
            message.messageType === "REJECTED_PERMISSION" /* rejected */) {
            return 3 /* Invitation */;
        }
        if (message.participant.company.id === companyId) {
            return 2 /* OutGoing */;
        }
        return 1 /* InComming */;
    };
    return CommunicationService;
}(BackendHttpService));
export { CommunicationService };



// WEBPACK FOOTER //
// ./src/app/services/communication/communication.service.ts.pre-build-optimizer.js